import { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import { hasAdminSession } from "../../auth/session";
import { apiCall } from "../../utils/apiService";
import "../AuthPage.css";

const AdminSignInLayer = () => {
  const { loginAdmin } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      const data = await apiCall({
        url: "admin/login",
        method: "POST",
        body: { email, password },
      });

      if (data.success && data.token) {
        // Does not clear user session
        loginAdmin(data.token, {
          uid: data.uid,
          admin: data.admin || { email, role: "admin", uid: data.uid },
        });
        window.location.href = "/admin/dashboard";
      } else {
        setError(data.msg || "Invalid email or password");
      }
    } catch (err) {
      setError("Invalid email or password");
      console.error("Admin login error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (hasAdminSession()) {
      window.location.href = "/admin/dashboard";
    } else {
      document.title = "Admin Sign In";
    }
  }, []);

  return (
    <div className="auth-page">
      <div className="auth-shell">
        <aside className="auth-aside">
          <div>
            <Icon icon="mdi:whatsapp" width={36} />
            <h2>WhatsApp messaging, made simple</h2>
            <p>
              Connect sessions, send campaigns, and monitor delivery from one
              AlphaXCloud workspace.
            </p>
            <ul className="auth-aside-points">
              <li><span className="dot" /> Multi-session WhatsApp inbox</li>
              <li><span className="dot" /> Bulk campaigns & templates</li>
              <li><span className="dot" /> Live logs and API access</li>
            </ul>
          </div>
          <p style={{ opacity: 0.8, fontSize: "0.8rem" }}>© AlphaXCloud</p>
        </aside>

        <div className="auth-panel">
          <Link to="/" className="d-block text-center">
            <img
              className="auth-logo"
              src="/assets/images/alphaxcloud.svg"
              alt="AlphaXCloud"
            />
          </Link>
          <h6>Sign in to admin</h6>
          <p className="auth-sub">Welcome back — enter your admin details to continue</p>

          <form onSubmit={handleSubmit}>
            <div className="icon-field">
              <span className="icon">
                <Icon icon="mage:email" />
              </span>
              <input
                type="email"
                className="form-control"
                placeholder="Email"
                value={email}
                required
                autoComplete="username"
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className="password-field">
              <div className="icon-field">
                <span className="icon">
                  <Icon icon="solar:lock-password-outline" />
                </span>
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control"
                  placeholder="Password"
                  value={password}
                  required
                  autoComplete="current-password"
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <button
                type="button"
                className="toggle-password"
                aria-label={showPassword ? "Hide password" : "Show password"}
                onClick={() => setShowPassword((v) => !v)}
              >
                <Icon
                  icon={showPassword ? "mdi:eye-off-outline" : "mdi:eye-outline"}
                  width={18}
                  height={18}
                />
              </button>
            </div>

            {error ? <div className="auth-error">{error}</div> : null}

            <button type="submit" className="auth-submit" disabled={isLoading}>
              {isLoading ? "Signing in…" : "Sign in"}
            </button>

            <div className="auth-footer">
              User account? <Link to="/login">Sign in here</Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminSignInLayer;
